import axios from "axios";
import { clearAllFilters } from "../utils/clearFilters";

const API_URL = `${process.env.REACT_APP_API_URL}`;

export const login = async (email, password) => {
  try {
    const response = await axios.post(`${API_URL}/login`, {
      email_id: email,
      password: password,
    });

    if (response.status === 200) {
      const token = response.data.token;
      clearAllFilters();
      localStorage.setItem("token", token);
      return token;
    } else {
      throw new Error(response.data.message || "Login failed");
    }
  } catch (error) {
    // ✅ Re-throw the original axios error so response.status is preserved
    throw error;
  }
};
